export default __webpack_public_path__ + "static/media/Foot_left.5ea31b46.svg";